import { apiClient } from './client';

/**
 * Katalog — javni deo API-ja (bez autentikacije).
 * Backend vraća samo aktivne proizvode; ugašeni nestaju iz kataloga.
 */

/** @returns {Promise<Array<{slug, name, description, imageUrl, sortOrder}>>} */
export const getCategories = async () => {
  const { data } = await apiClient.get('/categories');
  return data;
};

/**
 * @param {object} [params]
 * @param {string} [params.category] slug kategorije; izostavljen = svi proizvodi
 * @param {string} [params.q] pretraga po nazivu i opisu
 * @param {number} [params.page] 0-bazirano
 * @param {number} [params.size]
 * @returns {Promise<{content: Array, page: number, size: number, totalElements: number, totalPages: number}>}
 */
export const getProducts = async ({ category, q, page = 0, size = 12 } = {}) => {
  const { data } = await apiClient.get('/products', {
    params: { category: category || undefined, q: q || undefined, page, size },
  });
  return data;
};

/** Detalj proizvoda sa galerijom slika i varijantama. */
export const getProduct = async (slug) => {
  const { data } = await apiClient.get(`/products/${encodeURIComponent(slug)}`);
  return data;
};

export default { getCategories, getProducts, getProduct };
